// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_EditBucketModal_controls__LxWib > * {
  flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/containers/BucketsPageContent/modals/EditBucketModal/EditBucketModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;AACT","sourcesContent":[".controls > * {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": `storage_EditBucketModal_controls__LxWib`
};
export default ___CSS_LOADER_EXPORT___;
